import classNames from "classnames";
import React, { forwardRef, memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { leftNav as i18nNamespace } from "../../../../../../../i18n/namespace";
import leftNavStyles from "../../CategoriesNav.module.scss";
import useCurrentService from "utils/useCurrentService";
import { useHomeNavigation } from "../../hooks";
import { selectHomeData } from "../../selectors/LeftNavSelectors";

const Home = memo(forwardRef(({ onCategoryMenuItemClicked, isOpen, open, index, onKeyDown }, ref) => {
    const { t } = useTranslation(i18nNamespace);
    const { homeService } = useSelector(selectHomeData);
    const currentService = useCurrentService();
    
    const HomeBtnKeyDownHandler = useHomeNavigation(index, onKeyDown, onCategoryMenuItemClicked);

    const categoryClassName = useMemo(() =>
        classNames(leftNavStyles.category, {
            [leftNavStyles['category-active']]: homeService.newKey === currentService?.newKey
        }, leftNavStyles['category-label'], leftNavStyles['category-home']
    ), [homeService.newKey, currentService?.newKey]);

    return (
        <NavLink
            to={homeService.service.to}
            data-nav={homeService.newKey}
            className={classNames(leftNavStyles['sub-tab'], leftNavStyles['category-home-link'])}
            onClick={onCategoryMenuItemClicked}
            onKeyDown={HomeBtnKeyDownHandler}
            aria-label={t(homeService.name)}
            ref={ref}
        >
            <div
                className={categoryClassName}
                data-nav-category={homeService.name}
            >
                {t(homeService.name)}
            </div>
        </NavLink>
    );
}));

Home.displayName = 'Home';

export default Home;
